import { render, staticRenderFns } from "./couponPage.vue?vue&type=template&id=c4d0b93e&"
import script from "./couponPage.vue?vue&type=script&lang=js&"
export * from "./couponPage.vue?vue&type=script&lang=js&"
import style0 from "./couponPage.vue?vue&type=style&index=0&id=c4d0b93e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports